module.exports = __webpack_public_path__ + "static/media/img18.e595f3f3.JPG";